import { useEffect, useState } from "react";
import Swal from "sweetalert2";
import axios from "axios"; // Ensure axios is imported

const ApprovedZoneTrainerPage = () => {
  const [trainers, setTrainers] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchTrainers();
  }, []);

  // Function to fetch trainers based on the conditions
  const fetchTrainers = async () => {
    try {
      const response = await axios.get("/member/get_unapproved_zone_trainer", {
        params: {
          profession_id: "4", // Filter by profession_id = 4
          zone_trainer_status: "unapproved", // Filter by zone_trainer_status = unapproved
        },
      });

      if (response.data.success) {
        setTrainers(response.data.members);
      } else {
        return;
      }
    } catch (err) {
      console.error("Error fetching trainers:", err);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "An error occurred while fetching trainers. Please try again.",
        confirmButtonText: "OK",
      });
    } finally {
      setLoading(false); // Stop loading once data is fetched
    }
  };

  const handleApproval = async (id, status) => {
    try {
      const response = await axios.put(`/member/update_trainer_status`, {
        member_id: id,
        zone_trainer_status: status,
      });

      if (response.data.success) {
        // Swal.fire(`Trainer ${status}`, `Trainer ID: ${id} is now ${status.toLowerCase()}.`, 'success');
        Swal.fire(
          `Trainer ${status}`,
          `Trainer ID: ${id} is now ${status.toLowerCase()}.`,
          "success"
        );
        fetchTrainers(); // Refresh the trainers list after the status update
      } else {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: response.data.message || "Failed to update trainer status.",
          confirmButtonText: "OK",
        });
      }
    } catch (err) {
      console.error("Error updating trainer status:", err);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "An error occurred while updating the trainer status. Please try again.",
        confirmButtonText: "OK",
      });
    }
  };

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mt-16 space-y-6 mb-10">
      <div className="w-full max-w-7xl mx-auto mt-14 bg-white dark:bg-[#1a202c] rounded-xl shadow-2xl p-6">
        <div className="mb-6">
          <h1 className="text-2xl font-bold text-gray-800 mb-6">
            Unapproved Zone Trainers
          </h1>
          {loading ? (
            <p>Loading...</p> // Display loading message while fetching
          ) : (
            <table className="min-w-full border-collapse">
              <thead>
                <tr>
                  <th className="border px-4 py-2">Member ID</th>
                  <th className="border px-4 py-2">Membership ID</th>
                  <th className="border px-4 py-2">Zone Trainer Name</th>
                  <th className="border px-4 py-2">Contact Number</th>
                  <th className="border px-4 py-2">Actions</th>
                </tr>
              </thead>
              <tbody>
                {trainers.length > 0 ? (
                  trainers.map((trainer) => (
                    <tr key={trainer.member_id}>
                      <td className="border px-4 py-2">{trainer.member_id}</td>
                      <td className="border px-4 py-2">
                        {trainer.membership_id}
                      </td>
                      <td className="border px-4 py-2">
                        {trainer.zone_trainer_name}
                      </td>
                      <td className="border px-4 py-2">
                        {trainer.contact_number}
                      </td>
                      <td className="border px-4 py-2">
                        <button
                          onClick={() =>
                            handleApproval(trainer.member_id, "approved")
                          }
                          className="px-3 py-1 bg-green-500 text-white rounded-lg hover:bg-green-600"
                        >
                          Approve
                        </button>
                        <button
                          onClick={() =>
                            handleApproval(trainer.member_id, "unapproved")
                          }
                          className="ml-2 px-3 py-1 bg-red-500 text-white rounded-lg hover:bg-red-600"
                        >
                          Not Approve
                        </button>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="5" className="border px-4 py-2 text-center">
                      No trainers found with the specified criteria.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          )}
        </div>
      </div>
    </div>
  );
};

export default ApprovedZoneTrainerPage;
